import React from 'react';
import { lazyWithRetry } from '../../utils/lazyWithRetry';
import { Outlet } from 'react-router-dom';
import { AppRoute } from '../routes.types';

const FreemiumReportView = lazyWithRetry(() => import('../../containers/Reports/ViewReport/Freemium/latest-index'));
const FreemiumReport = lazyWithRetry(() => import('../../containers/Reports/Freemium/Freemium'));
const PaidEvaluation = lazyWithRetry(() => import('../../containers/Reports/PaidEvaluation/PaidEvaluation'));
const ApvarReportInput = lazyWithRetry(() => import('../../containers/Reports/ApvarReport/ApvarReportInput'));
const PaidEvaluationReport = lazyWithRetry(() => import('../../containers/Reports/ViewReport/PaidEvaluationReport'));
const DetailedReports = lazyWithRetry(() => import('../../containers/DetailedReports/DetailedReports'));

export const REPORT_ROUTES: AppRoute[] = [
    {
        path: '/report',
        element: <Outlet />,
        withAppShell: true,
        children: [
            { path: 'free', element: <FreemiumReport /> },
            { path: 'evaluation', element: <PaidEvaluation /> },
            { path: 'apvarinput', element: <ApvarReportInput /> },
        ],
    },
    { path: '/view/freemium/:id', element: <FreemiumReportView />, withAppShell: true },
    { path: '/view/paidevaluation/:id', element: <PaidEvaluationReport />, withAppShell: true },
    { path: '/detailedreports', element: <DetailedReports /> },
];
